<template>
    <div>
        <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">{{ $t('team_culture') }}</h5>
            <button class="btn btn-primary" @click="openModal">{{ $t('create') }}</button>
        </div>
        <app-table :id="'team-culture-list-table'" :options="options" @action="getAction"/>

        <team-culture-create-edit-modal
            v-if="isModalActive"
            :table-id="'team-culture-list-table'"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            @close="closeModal"
        />

        <team-culture-view-modal
            v-if="isViewModalActive"
            v-model="isViewModalActive"
            :selected-url="selectedUrl"
            @close="closeViewModal"
        />
    </div>
</template>

<script>
import TeamCultureListMixin from "../../../Mixins/TeamCultureListMixin";
import {TEAM_CULTURE} from "../../../Config/ApiUrl";
import TeamCultureCreateEditModal from "./Component/TeamCultureCreateEditModal.vue";
import TeamCultureViewModal from "./Component/TeamCultureViewModal.vue";

export default {
    name: "TeamCultureList",
    mixins: [TeamCultureListMixin],
    components: {TeamCultureCreateEditModal, TeamCultureViewModal},
    props: {
        status: {}
    },
    data() {
        return {
            isModalActive: false,
            isViewModalActive: false,
            selectedUrl: '',
            options: {
                name: "TeamCultureList",
                url: TEAM_CULTURE,
                showHeader: true,
                columns: [
                    {
                        title: this.$t('title'),
                        type: 'text',
                        key: 'title',
                    },
                    {
                        title: this.$t('status'),
                        type: 'text',
                        key: 'is_active',
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action',
                        key: 'invoice',
                        isVisible: true
                    },
                ],
                filters: [
                    {
                        title: this.$t('created_date'),
                        type: "date-picker",
                        key: "date",
                        option: ["today", "this_month", "last_month", "this_year"]
                    },
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
                actions: [
                    {
                        title: this.$t('view'),
                        icon: 'eye',
                        type: 'none',
                        component: 'team-culture-view-modal',
                        modalId: 'team-culture-view-modal',
                        name: 'view',
                        modifier: () => true
                    },
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        name: 'edit',
                        modifier: () => this.$can('update_team_cultures')
                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash-2',
                        name: 'delete',
                        modifier: () => this.$can('delete_team_cultures')
                    }
                ],
                buttons: {
                    header: {
                        title: this.$t('add_team_culture'),
                        icon: 'plus',
                        class: 'btn-primary',
                        click: () => {
                            this.openModal();
                        },
                        modifier: () => {
                            return this.$can('create_team_cultures');
                        }
                    }
                }
            }
        }
    },
    methods: {
        getAction(row, action, active) {
            if (action.name === 'edit') {
                this.selectedUrl = `${TEAM_CULTURE}/${row.id}`;
                this.openModal();
            } else if (action.name === 'delete') {
                this.$hub.$emit('show-delete-confirmation', {
                    url: `${TEAM_CULTURE}/${row.id}`,
                    tableId: 'team-culture-list-table'
                });
            } else if (action.name === 'view') {
                this.selectedUrl = `${TEAM_CULTURE}/${row.id}`;
                this.openViewModal();
            }
        },

        openModal() {
            this.isModalActive = true;
        },

        closeModal() {
            this.isModalActive = false;
            this.selectedUrl = '';
        },

        openViewModal() {
            this.isViewModalActive = true;
        },

        closeViewModal() {
            this.isViewModalActive = false;
            this.selectedUrl = '';
        }
    }
}
</script>
